import ErrorResponse from '../../../components/ErrorResponse';
import Loader from '../../../components/Loader';
import Header from '../../../components/layout/Header';
import { useHistory } from 'react-router';
import useAxios from '../../../hooks/useAxios';
import SpeakingItemEditor from '../../../components/cbt/speaking-item/Editor';
import { ISpeakingItem } from '../../../models/speaking.model';
import { createSpeakingItem } from '../../../api/speaking.api';
import { useEffect } from 'react';
import useNotification from '../../../hooks/useNotification';
import { useTranslation } from 'react-i18next';

const CbtSpeakingItemCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/cbt/speaking-item');
    }
  }, [res, isLoading]);

  const onSubmit = (req: ISpeakingItem) => {
    execute(createSpeakingItem(req));
  };

  return (
    <div className="content-wrapper">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Header parentMenu="CBT" currentMenu={t('cbt.speakingItem.5')} />

      <div className="main max-w1200p">
        <SpeakingItemEditor onSubmit={onSubmit} />
      </div>
    </div>
  );
};

export default CbtSpeakingItemCreate;
